import {
  collection,
  doc,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  query,
  where,
  orderBy,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

// Create booking (client)
export const createBooking = async (bookingData) => {
  const bookingsRef = collection(db, 'bookings');
  const docRef = await addDoc(bookingsRef, {
    ...bookingData,
    status: 'pending',
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
  });
  return docRef.id;
};

// Get booking by ID
export const getBooking = async (bookingId) => {
  const bookingDoc = await getDoc(doc(db, 'bookings', bookingId));
  if (!bookingDoc.exists()) {
    return null;
  }
  return { id: bookingDoc.id, ...bookingDoc.data() };
};

// Get bookings by client
export const getClientBookings = async (clientId) => {
  const bookingsRef = collection(db, 'bookings');
  const q = query(
    bookingsRef,
    where('clientId', '==', clientId),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Get bookings by host
export const getHostBookings = async (hostId) => {
  const bookingsRef = collection(db, 'bookings');
  const q = query(
    bookingsRef,
    where('hostId', '==', hostId),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Get inquiries by host (type: 'inquiry')
export const getHostInquiries = async (hostId) => {
  const bookingsRef = collection(db, 'bookings');
  const q = query(
    bookingsRef,
    where('hostId', '==', hostId),
    where('type', '==', 'inquiry'),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Get bookings by host (type: 'booking' or no type)
export const getHostBookingsOnly = async (hostId) => {
  const bookingsRef = collection(db, 'bookings');
  const q = query(
    bookingsRef,
    where('hostId', '==', hostId),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs
    .map(doc => ({ id: doc.id, ...doc.data() }))
    .filter(booking => !booking.type || booking.type === 'booking');
};

// Get inquiries by client
export const getClientInquiries = async (clientId) => {
  const bookingsRef = collection(db, 'bookings');
  const q = query(
    bookingsRef,
    where('clientId', '==', clientId),
    where('type', '==', 'inquiry'),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Get bookings by trip
export const getTripBookings = async (tripId) => {
  const bookingsRef = collection(db, 'bookings');
  const q = query(
    bookingsRef,
    where('tripId', '==', tripId),
    orderBy('createdAt', 'desc')
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Update booking status
export const updateBookingStatus = async (bookingId, status) => {
  const bookingRef = doc(db, 'bookings', bookingId);
  await updateDoc(bookingRef, {
    status,
    updatedAt: Timestamp.now(),
  });
};

// Cancel booking (client can cancel their own)
export const cancelBooking = async (bookingId) => {
  await updateBookingStatus(bookingId, 'canceled');
};

